module.exports = __webpack_public_path__ + "img/stairs2.8e1d3d63.png";